"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeHealthMd = void 0;
const helper_1 = require("../../helper");
const EmrConstants_1 = require("../../EmrConstants");
class HomeHealthMd {
    constructor() { }
    parse(pastedData, event, callbackEmit) {
        try {
            //**Session 1 Patient name*/
            const patientDetails = (0, helper_1.substrInBetween)(pastedData, EmrConstants_1.PARSER_INPUT_TYPE.PERSONAL_INFO, EmrConstants_1.PARSER_INPUT_TYPE.ALLERGIES);
            //**Patient Information*/
            const patientInfo = this.gettingPatientDetails(patientDetails);
            //**Session 3 Insurance*/
            const insuranceInfo = (0, helper_1.substrInBetween)(pastedData, EmrConstants_1.PARSER_INPUT_TYPE.INSURANCE, EmrConstants_1.PARSER_INPUT_TYPE.DATES_OF_SERVICE);
            const insurance = this.getInsurance(insuranceInfo);
            //**Session 6 Emergency Contact*/
            const emergencyContact = (0, helper_1.substrInBetween)(pastedData, EmrConstants_1.PARSER_INPUT_TYPE.EMERGENCY_CONTACT_EC, EmrConstants_1.PARSER_INPUT_TYPE.AR_OR_EC);
            //**Session 7 Primary Physician*/
            const physicianDetails = (0, helper_1.substrInBetween)(pastedData, EmrConstants_1.PARSER_INPUT_TYPE.PHYSICIAN_INFO, EmrConstants_1.PARSER_INPUT_TYPE.PAGE);
            const physicianInfo = this.getPrimaryPhysician(emergencyContact, physicianDetails, "");
            const sendCallBackData = Object.assign(Object.assign(Object.assign({}, patientInfo), insurance), physicianInfo);
            //@callback
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error === null || error === void 0 ? void 0 : error.message : error,
                errorStack: error === null || error === void 0 ? void 0 : error.stack,
            });
        }
    }
    /**
     * @function gettingPatientDetails
     * @param patientDetails {String}
     * @param sessionSecond {String}
     * @summary Getting Patient name, number, email, dob, address from kinnserHospice
     */
    gettingPatientDetails(patientDetails) {
        let dob;
        if (!patientDetails) {
            return {};
        }
        patientDetails = patientDetails.substr(0, patientDetails.indexOf(EmrConstants_1.PARSER_INPUT_TYPE.INSURANCE));
        const browser = (0, helper_1.detectionBrowser)();
        if (browser == EmrConstants_1.BROWSERS.CHROME &&
            !patientDetails.includes(EmrConstants_1.PARSER_INPUT_TYPE.ErrorSSN)) {
            dob = (0, helper_1.substrInBetween)(patientDetails, EmrConstants_1.PARSER_INPUT_TYPE.DOB, EmrConstants_1.PARSER_INPUT_TYPE.LAST_NAME);
        }
        if (browser == EmrConstants_1.BROWSERS.CHROME &&
            patientDetails.includes(EmrConstants_1.PARSER_INPUT_TYPE.ErrorSSN)) {
            dob = (0, helper_1.substrInBetween)(patientDetails, EmrConstants_1.PARSER_INPUT_TYPE.ErrorSSN, EmrConstants_1.PARSER_INPUT_TYPE.DOB);
        }
        else if (browser == EmrConstants_1.BROWSERS.FIREFOX &&
            !patientDetails.includes(EmrConstants_1.PARSER_INPUT_TYPE.ErrorSSN)) {
            dob = (0, helper_1.substrInBetween)(patientDetails, EmrConstants_1.PARSER_INPUT_TYPE.DOB, EmrConstants_1.PARSER_INPUT_TYPE.LAST_NAME);
        }
        else if (browser == EmrConstants_1.BROWSERS.FIREFOX &&
            patientDetails.includes(EmrConstants_1.PARSER_INPUT_TYPE.ERRORDOB)) {
            dob = (0, helper_1.substrInBetween)(patientDetails, EmrConstants_1.PARSER_INPUT_TYPE.ERRORDOB, EmrConstants_1.PARSER_INPUT_TYPE.LAST_NAME);
        }
        if (dob) {
            dob = (0, helper_1.trim)(dob);
        }
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(patientDetails)), this.patientPhoneNumberWithAddress(patientDetails)), { email: (0, helper_1.getEmailAddress)(patientDetails), dob: dob && (0, helper_1.getDOB)(dob, true) }),
        };
    }
    /**
     * @function getPrimaryPhysician
     * @param data
     * @param sessionEight
     * @summary Getting Physician and Pharmacy from kinnserHospice
     */
    getPrimaryPhysician(emergencyContact, physicianDetails, sessionEight) {
        const primaryPhy = {
            info: {
                physician: [
                    {
                        name: "",
                        phoneNo: "",
                        countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                        sortOrder: 1,
                    },
                ],
            },
        };
        const browser = (0, helper_1.detectionBrowser)();
        if (browser == EmrConstants_1.BROWSERS.CHROME) {
            const breaker = physicianDetails.indexOf(EmrConstants_1.PARSER_INPUT_TYPE.DIFFERENT_OFFFICE) != -1
                ? EmrConstants_1.PARSER_INPUT_TYPE.DIFFERENT_OFFFICE
                : EmrConstants_1.PARSER_INPUT_TYPE.SELF;
            var phyInfo = this.getPatPhyCareDetails(physicianDetails.substr(0, physicianDetails.indexOf(EmrConstants_1.PARSER_INPUT_TYPE.FAX)), breaker);
        }
        else if (browser == EmrConstants_1.BROWSERS.FIREFOX &&
            physicianDetails.indexOf(EmrConstants_1.PARSER_INPUT_TYPE.SELF) != -1) {
            var phyInfo = this.getPatPhyCareDetails(physicianDetails.substr(0, physicianDetails.indexOf(EmrConstants_1.PARSER_INPUT_TYPE.SELF)), EmrConstants_1.PARSER_INPUT_TYPE.FAMILY_MEDICINE);
        }
        else {
            var phyInfo = this.getPatPhyCareDetails(physicianDetails.substr(0, physicianDetails.indexOf(EmrConstants_1.PARSER_INPUT_TYPE.PHYSICIAN_INFO)), EmrConstants_1.PARSER_INPUT_TYPE.FAMILY_MEDICINE);
        }
        primaryPhy.info.physician[0].name = phyInfo.name;
        primaryPhy.info.physician[0].phoneNo = phyInfo.phoneNo;
        return primaryPhy;
    }
    /**
     * @function getInsurance
     * @param insuranceInfo
     * @summary Getting Insurance from kinnserHospice
     */
    getInsurance(insuranceInfo) {
        if (!insuranceInfo) {
            return {};
        }
        const insuranceName = (0, helper_1.substrInBetween)(insuranceInfo, EmrConstants_1.PARSER_INPUT_TYPE.VALID_TILL_PRIMARY, "$");
        //Primary Insurance and Secondary Insurance
        return { insurance: (0, helper_1.trim)(insuranceName) };
    }
    getPatPhyCareDetails(data, breakName) {
        const info = {
            name: "",
            phoneNo: "",
        };
        //Blank data Return
        if (!data) {
            return info;
        }
        const breakPhyData = data.split(/\n/g);
        for (let phyInfo of breakPhyData) {
            if (phyInfo.indexOf(breakName) !== -1) {
                const physicianName = phyInfo.slice(0, phyInfo.indexOf(","));
                info.name = (0, helper_1.trim)(physicianName.replace(breakName, ""));
            }
            if (phyInfo.indexOf(EmrConstants_1.PARSER_INPUT_TYPE.PHONE) !== -1) {
                phyInfo = (0, helper_1.substrInBetween)(phyInfo, EmrConstants_1.PARSER_INPUT_TYPE.PHONE_BREAK, EmrConstants_1.PARSER_INPUT_TYPE.SEPERATOR_SYMBOL);
                phyInfo = phyInfo.replace(/[\s-()]/g, "");
                info.phoneNo = (0, helper_1.changeNumberUSFormat)(phyInfo).replace("--");
                break;
            }
        }
        return info;
    }
    /**
     * @function patientPhoneNumberWithAddress
     * @param firstSession
     * @summary Patient number or Address both are same session
     */
    patientPhoneNumberWithAddress(firstSession) {
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
            },
        };
        let pAddress = (0, helper_1.substrInBetween)(firstSession, EmrConstants_1.PARSER_INPUT_TYPE.ADDRESS, EmrConstants_1.PARSER_INPUT_TYPE.PRIM_PHONE);
        const browser = (0, helper_1.detectionBrowser)();
        let pNumber = (0, helper_1.substrInBetween)(firstSession, EmrConstants_1.PARSER_INPUT_TYPE.PRIM_PHONE, EmrConstants_1.PARSER_INPUT_TYPE.ALT_PHONE);
        if (pAddress) {
            pAddress = pAddress.replace(/[\n]/g, " ");
            info.address.placeName = pAddress;
        }
        if (pNumber) {
            pNumber = (0, helper_1.trim)(pNumber).replace("(", "");
            pNumber = (0, helper_1.trim)(pNumber).replace(")", "");
            pNumber = (0, helper_1.trim)(pNumber).replace(/ /g, "");
            info.phoneNo = (0, helper_1.changeNumberUSFormat)(pNumber).replace("--", "-");
        }
        return info;
    }
    /**
     * @function patientName
     * @param patientDetails {String}
     * @summary Getting Patient First name, Last name from string
     * @returns {name} FullName
     */
    patientName(patientDetails) {
        const name = {
            firstName: "",
            lastName: "",
        };
        const findPatientName = patientDetails.split(/\n/g);
        for (const pName of findPatientName) {
            if (pName.indexOf(EmrConstants_1.PARSER_INPUT_TYPE.FIRST_NAME) !== -1) {
                const firstName = pName.slice(pName.indexOf(EmrConstants_1.PARSER_INPUT_TYPE.FIRST_NAME));
                const FName = firstName.split(" ")[2];
                if (!FName) {
                    return;
                }
                name.firstName = (0, helper_1.trim)(FName);
            }
            if (pName.indexOf(EmrConstants_1.PARSER_INPUT_TYPE.LAST_NAME) !== -1) {
                const lastName = (0, helper_1.substrInBetween)(pName, EmrConstants_1.PARSER_INPUT_TYPE.LAST_NAME, EmrConstants_1.PARSER_INPUT_TYPE.FIRST_NAME);
                const LName = lastName.replace(EmrConstants_1.PARSER_INPUT_TYPE.LAST_NAME, "");
                if (!LName) {
                    return;
                }
                name.lastName += (0, helper_1.trim)(LName);
                break;
            }
        }
        return name;
    }
}
exports.HomeHealthMd = HomeHealthMd;
